module.exports = __webpack_public_path__ + "img/drugs.fd6c8a5.svg";